import { Cms, SubPage, accountTemplate, accountTemplateCol, Template, UserCredential } from './../models/cms.model';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgProgress } from 'ngx-progressbar';
import { CmsStudioService } from '../cms-studio.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2'
import { Observable, Subscription } from 'rxjs';
import { CommonService } from '../../services';
import { AuthService } from '../../services/auth.service';
import { CurrentUserModel } from '../../models/account-ledger.model';
import { DragulaService } from 'ng2-dragula';
import { NgProgressService } from '../../services/ngProgress.service';

@Component({
  selector: 'app-cms-studio',
  templateUrl: './cmsstudio.component.html',
  styleUrls: ['../cmsstudio.component.css'],
})

export class CmsStudioComponent implements OnInit {
  title: string = "CMS - Studio";
  setFullWindow = false;
  component: any;
  newCms = new Cms();

  froalaOptions = {
    //key: 'uXD2lC7D6G5E4B3A3A11dNSWXf1h1MDb1CF1PLPFf1C1EESFKVlA3C11A8D7D2B4D4G2C3B2==',
    key: 'uB1A1E6C7D6B4C4iB3B9B6E5C2C4D3H3A2I3C-22NGNb1IODMGYNSFKV==',
    //custom buttons
    /*toolbarButtons: ['fullscreen', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript',
      '|', 'fontFamily', 'fontSize', 'color', 'inlineClass', 'inlineStyle', 'paragraphStyle', 'lineHeight',
      '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote',
      '-', 'insertLink', 'insertImage', 'embedly', 'insertTable',
      '|', 'fontAwesome', 'specialCharacters', 'clearFormatting',
      '|', 'undo', 'redo', 'html',
      '|', 'cmsInsert'],*/
    /*toolbarButtons: ['fullscreen', '|', 'paragraphFormat', '|', 'bold', 'italic', 'underline', 'color', 'strikeThrough', 'subscript', 'superscript', '|',
      'formatOL', 'formatUL', '|', 'outdent', 'indent', '|', 'align', '|', 'insertFile', 'insertImage', 'insertVideo', '|',
      'insertLink', 'insertTable', 'insertHR', '|', 'print', 'fontAwesomeform-control cms-page-search', '|',
      'undo', 'redo', '|', 'html', 'cmsInsert', '|', 'singleCard', 'doubleCard', 'tripleCard'],*/

    inlineClasses: {
      fl_heading: 'Heading',
      fl_subheading: 'Sub Heading',
      fl_code: 'Code'
    },

    paragraphFormat: {
      N: 'Normal',
      H3: 'Heading',
      H5: 'Sub Heading',
      PRE: 'Code'
    },

    toolbarButtons: ['fullscreen', 'paragraphFormat', '|', 'inlineClasses', 'formatOL', 'formatUL', '|', 'outdent', 'indent', '|', 'align', '|', 'insertFile', 'insertImage', 'insertVideo', '|',
      'insertLink', 'insertTable', 'insertHR', '|', 'print', 'fontAwesomeform-control cms-page-search', '|',
      'undo', 'redo', '|', 'html', 'cmsInsert', '|', 'singleCard', 'doubleCard', 'tripleCard'],
    //When this options is disabled the edited content will have the external CSS properties converted to inline style. 
    //For this option to work correctly, it is necessary to load the CSS files from the same domain the editor is running on.
    useClasses: false,
    charCounterCount: false,
    // Set the image upload parameter.
    imageUploadParam: 'image_param',
    // Set the image upload URL.
    imageUploadURL: this.cmsStudioService.apiHost + '/api/uploadcmstemplateimage' + this.cmsStudioService.masterKey,
    // Additional upload params.
    imageUploadParams: { id: 'my_editor' },
    // Set request type.
    imageUploadMethod: 'POST',
    // Set max image size to 5MB.
    // imageMaxSize: 5 * 1024 * 1024,
    // Allow to upload PNG and JPG.
    imageAllowedTypes: ['jpeg', 'jpg', 'png'],
    height: 'calc(100vh - 300px)',
    theme: 'custom',
    quickInsertButtons: [],
    quickInsertTags: [],

    fileUploadParam: 'image_param',
    fileUploadURL: this.cmsStudioService.apiHost + '/api/uploadcmstemplateimage' + this.cmsStudioService.masterKey,
    fileUploadParams: { id: 'my_editor' },
    fileUploadMethod: 'POST',
    //The URL where the HTTP request is done to delete the image. The request will contain the image source as src parameter.
    //imageManagerDeleteURL: 'http://example.com/delete_image'

    events: {
      'froalaEditor.file.inserted': function (e, editor, $file, response) {
        // File was inserted in the editor.              
        $file.attr("target", "_self");
        $file.attr("download", true);
        // console.log($file[0]);
        editor.file.insert(response.link, false, null, editor.file.get(), null);
      }
    }
  };

  @ViewChild("froalaEditorDiv") froalaEditorDiv;
  @ViewChild("addPageModal") addPageModal;
  postMsg = null;
  isDisableSubmit = false;
  cmsList: Array<Cms> = [];
  cmsSourceList: Array<Cms> = [];
  selectedCms: Cms;
  selectedSubPageId: string;

  selectedTemplate = new Template();
  templateList: Array<Template> = [];

  cmsTemplateSelection: boolean = false;
  cmsInserted: boolean = false;
  @ViewChild("linkExistingTemplateModal") linkExistingTemplateModal;
  @ViewChild("openModalButton") openModalButton;
  insertTemplateName: string;
  insertedCmsId: string;
  selectedSearchTemplate: Cms;
  isLoadingSearchTemplate = false;

  searchTemplateList: Array<Cms> = [];
  isSubmitForm = false;

  isSubPageSelected: boolean;
  subPageParentCms: Cms;

  isShowEditor = false;

  currentUserModel: CurrentUserModel;
  accountId: string;
  loginId: string;
  companyCode: string;

  // loggedInUser: UserCredential = { userName: 'murali', accountId: '123123' };
  subs = new Subscription();
  loadContent = false;
  constructor(
    private router: Router,
    public ngProgress: NgProgressService,
    private activeRouter: ActivatedRoute,
    private cmsStudioService: CmsStudioService,
    private modalService: NgbModal,
    private authService: AuthService,
    private commonService: CommonService,
    private dragulaService: DragulaService
  ) {
    this.subs.add(dragulaService.dropModel('DRGULA_CONTAINER')
      .subscribe(({ el, target, source, sourceModel, targetModel, item }) => {
        /*console.log(sourceModel)
        console.log(targetModel)
        console.log(item)
        console.log(el)
        console.log(target)
        console.log(source)*/
        //this.surveyquestions = sourceModel;
      }));
  }

  ngOnInit() {
    this.loadContent = false;
    this.addNewCms();
    var accountTemp = accountTemplate;
    var accountTempCol = "";
    for (var i = 0; i < 6; i++) {
      accountTempCol = accountTempCol + accountTemplateCol;

      if (i == 5)
        accountTemp = accountTemp.replace('accountTemplateCol', accountTempCol);
    }
    //console.log('at' + accountTemp);
    this.templateList.push({ name: 'Template - 6 Widgets', innerHtml: accountTemp });
    this.templateList.push({ name: 'Template - Page Title', innerHtml: "<h1>Title</h1><p>Description</p>" });

    this.ngProgress.start();
    this.authService.getLoginInfo().subscribe((res: CurrentUserModel) => {
      this.currentUserModel = res;
      this.accountId = this.currentUserModel.accountId;
      this.loginId = this.currentUserModel.loginId;
      this.companyCode = this.currentUserModel.companyCode;
      this.getAllActiveCms(true);
      // this.froalaInit();
      this.ngProgress.done();
    });

  }

  addNewCms() {
    this.newCms = new Cms();
    this.newCms.isActive = true;
  }

  createOrUpdateCms(form) {
    this.isSubmitForm = true;
    /*var postCms = null;
    if (this.selectedCms) {
      var newSubPage = new SubPage();
      newSubPage.id = new Date().getTime().toString();
      newSubPage.superParent_id = this.selectedCms._id;
      newSubPage.isActive = true;
      newSubPage.title = this.newCms.title;
      newSubPage.innerHtml = this.newCms.innerHtml;
      newSubPage.subPages = [];
      if (!this.newCms.id && !this.newCms.hasOwnProperty('_id'))
        this.pushSubPageIntoSubPage(newSubPage);
      else {
        if (this.newCms.hasOwnProperty('_id')) {
          this.selectedCms.innerHtml = this.newCms.innerHtml;
          this.selectedCms.title = this.newCms.title;
        }
        else {
          var findItem = this.findById(this.selectedCms.subPages, this.selectedSubPageId);
          findItem.id = this.newCms.id;
          findItem.innerHtml = this.newCms.innerHtml;
          findItem.title = this.newCms.title;
        }
      }
      console.log(this.selectedCms);
      postCms = this.selectedCms;
    }
    else {
      postCms = this.newCms;
    }*/

    if (form.valid) {
      if (this.selectedCms && this.selectedCms._id == this.newCms._id) {
        this.createOrUpdateHelper(this.newCms, false);
      } else {
        if (this.selectedCms) this.newCms.isOnlySubPage = true;
        this.newCms.companyCode = this.companyCode;
        this.cmsStudioService.createOrUpdateCms(this.newCms)
          .subscribe(res => {
            //console.log(res);
            this.newCms = res.cms;
            this.isSubmitForm = false;
            if (this.selectedCms) {
              var newSubPage = new SubPage();
              newSubPage.isActive = true;
              newSubPage.title = this.newCms.title;
              newSubPage._id = res.cms._id;

              if (!this.selectedCms.subPages) this.selectedCms.subPages = [];
              this.selectedCms.subPages.push(newSubPage);

              this.createOrUpdateHelper(this.selectedCms, false);
            }
            else {
              this.isDisableSubmit = false;
              this.postMsg = "Template has been updated succesfully."//res.message;          
              setTimeout(() => { this.postMsg = null }, 3000);
              this.getAllActiveCms();
              //this.addNewCms();
              this.newCms = res.cms;
            }
          });
      }
    }
  }

  createOrUpdateHelper(cms, isparent) {
    this.postMsg = null;
    this.isDisableSubmit = true;
    cms.companyCode = this.companyCode;
    this.cmsStudioService.createOrUpdateCms(cms)
      .subscribe(res => {
        this.isSubmitForm = false;
        this.isDisableSubmit = false;
        this.postMsg = "Template has been updated succesfully."//res.message;          
        setTimeout(() => { this.postMsg = null }, 3000);
        this.getAllActiveCms();
        //this.addNewCms();
        if (isparent)
          this.newCms = res.cms;
      });
  }

  getCmsById(id, owner?, contr?) {
    this.cmsStudioService.getCmsById(id)
      .subscribe(res => {
        this.newCms = res.count;

        if (owner)
          this.newCms.owners = owner;
        if (contr)
          this.newCms.contributors = contr;
        console.log(res);
      })
  }

  /*pushSubPageIntoSubPage(newSubPage: SubPage) {
    if (this.selectedSubPageId == null) {
      if (this.selectedCms.subPages == null)
        this.selectedCms.subPages = [];
      this.selectedCms.subPages.push(newSubPage);
    }
    else {
      var subItem = this.findById(this.selectedCms.subPages, this.selectedSubPageId);
      if (!subItem.subPages) subItem.subPages = [];
      subItem.subPages.push(newSubPage);
    }
  }

  findById(data, id) {
    console.log(data);
    for (var i = 0; i < data.length; i++) {
      if (data[i].id == id) {
        console.log("inside if");
        console.log(data[i]);
        return data[i];
      } else if (data[i].subPages && data[i].subPages.length && typeof data[i].subPages == "object") {
        return this.findById(data[i].subPages, id);
      }
    }
  }*/

  getAllActiveCms(oninit?) {
    this.loadContent = true;
    this.cmsStudioService.getAllActiveCms(this.companyCode)
      .subscribe(res => {
       
        if (oninit)
          this.cmsList = res.cms;
        else {
          var existingCms = this.cmsList;
          this.cmsList = [];
          res.cms.forEach(rcms => {
            var eindex = existingCms.findIndex(ex => ex._id == rcms._id);
            if (eindex >= 0) {
              rcms.isShowSubpages = existingCms[eindex].isShowSubpages;
              this.cmsList.push(rcms);
            }
            else {
              this.cmsList.push(rcms);
            }
            //console.log(rcms);
          })
        }
        this.cmsSourceList = res.cms;
        this.cmsList = res.cms;

        // this.cmsList.forEach(element => {
        //   console.log(element.title);
        //   console.log(element._id);
        //   console.log(element.subPages.length);
        // });
        this.loadContent = false;
      })
  }

  openAddPageModal() {
    this.newSelectedTemplate();
    const modal = this.modalService.open(this.addPageModal, { centered: true, windowClass: 'link-existing-modal', size: 'lg' });
    modal.result.then(() => {
      /*this.searchTemplateList = null;
      this.selectedSearchTemplate = null;
      this.insertTemplateName = null;*/
    }, () => {
      /*this.searchTemplateList = null;
      this.selectedSearchTemplate = null;
      this.insertTemplateName = null;*/
    })
  }

  newSelectedTemplate() {
    this.selectedTemplate = new Template();
  }

  makeAsHomePage() {
    this.newCms.isHomePage = true;
    Swal.fire(
      'Information!',
      'Changes only take effect after save the template',
      'info'
    )
  }

  froalaInit() {
    var _this1 = this;
    $['FroalaEditor'].DefineIcon('alert', { NAME: 'info' });
    $['FroalaEditor'].DefineIcon('cmsInsert', { NAME: 'object-ungroup' });
    $['FroalaEditor'].DefineIcon('singleCard', { NAME: 'columns' });
    $['FroalaEditor'].DefineIcon('doubleCard', { NAME: 'columns' });
    $['FroalaEditor'].DefineIcon('tripleCard', { NAME: 'columns' });

    $['FroalaEditor'].RegisterCommand('cmsInsert', {
      title: 'CMS Insert',
      focus: false,
      undo: false,
      refreshAfterCallback: true,
      callback: function () {
        _this1.cmsTemplateSelection = true;
        _this1.cmsInserted = false;
        this.selection.save();
        _this1.openModalButton.nativeElement.click();
        _this1.cmsInsert()
          .subscribe(res => {
            console.log(res);
            if (res.stat == "selected") {
              //this.selection.save(); 
              this.selection.restore();
              this.html.insert(res.content, true);
              this.undo.saveStep();
              //this.selection.save(); 
              //this.selection.restore();                                       
              /*$['FroalaEditor'].froalaEditor('saveSelectionByMarkers');
              $['FroalaEditor'].froalaEditor('setHTML', this.state.content);
              $['FroalaEditor'].froalaEditor('restoreSelectionByMarkers');*/
            }
          });
      }
    });

    $['FroalaEditor'].DefineIcon('insertHTML', { NAME: 'plus' });
    $['FroalaEditor'].RegisterCommand('insertHTML', {
      title: 'Insert HTML',
      focus: true,
      undo: true,
      refreshAfterCallback: true,
      callback: function () {
        this.html.insert('Some Custom HTML.');
        this.undo.saveStep();
      }
    });

    $['FroalaEditor'].RegisterCommand('singleCard', {
      title: 'Single Card',
      focus: false,
      undo: false,
      refreshAfterCallback: true,
      callback: function () {
        this.selection.save();
        this.selection.restore();
        this.html.insert(_this1.getCardHtmlByNo(1), true);
        this.undo.saveStep();
      }
    });

    $['FroalaEditor'].RegisterCommand('doubleCard', {
      title: 'Double Card',
      focus: false,
      undo: false,
      refreshAfterCallback: true,
      callback: function () {
        this.selection.save();
        this.selection.restore();
        this.html.insert(_this1.getCardHtmlByNo(2), true);
        this.undo.saveStep();
      }
    });

    $['FroalaEditor'].RegisterCommand('tripleCard', {
      title: 'Triple Card',
      focus: false,
      undo: false,
      refreshAfterCallback: true,
      callback: function () {
        this.selection.save();
        this.selection.restore();
        this.html.insert(_this1.getCardHtmlByNo(3), true);
        this.undo.saveStep();
      }
    });

    /*$['FroalaEditor'].DefineIcon('headingDropdown', {NAME: 'cog', SVG_KEY: 'cogs'});
    $['FroalaEditor'].RegisterCommand('headingDropdown', {
      title: 'Formating',
      type: 'dropdown',
      focus: false,
      undo: false,
      refreshAfterCallback: true,
      options: {
        'v1': '<strong>Heading</strong>',
        'v2': '<strong>Sub Heading</strong>',
        'v3': 'Code'
      },
      callback: function (cmd, val) {
        console.log (val);
        this.paragraphFormat.apply(cmd);
      },
      // Callback on refresh.
      refresh: function ($btn) {
        console.log ('do refresh');
      },
      // Callback on dropdown show.
      refreshOnShow: function ($btn, $dropdown) {
        console.log ('do refresh when show');
      }
    });*/


  }

  getCardHtmlByNo(no) {
    var card = '<div style="width: calc(' + 100 / no + '% - 15px);float: left;box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);border-radius: 5px; margin-right: 15px">' +
      '<div style="padding: 33px 38px;">' +
      '<div style="font-family: Roboto;font-style: normal;font-weight: 300;line-height: normal;font-size: 18px;color: #2F3238;">' +
      'Title 1' +
      '</div>' +
      '<div style="font-family: Roboto;font-style: normal;font-weight: normal;line-height: 13px;font-size: 9px;color: #808080;">' +
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque vestibulum ex nec eleifend luctus. Nam.' +
      '</div>' +
      '<div style="margin-top: 30px">' +
      '<div style="font-family: Roboto;font-style: normal;font-weight: normal;line-height: normal;font-size: 10px; color: #2F3238; margin-bottom: 20px">' +
      'Option 1' +
      '</div>' +
      '<div style="font-family: Roboto;font-style: normal;font-weight: normal;line-height: normal;font-size: 10px;color: #2F3238; margin-bottom: 20px">' +
      'Option 2' +
      '</div>' +
      '<div style="font-family: Roboto;font-style: normal;font-weight: normal;line-height: normal;font-size: 10px;color: #2F3238;">' +
      'Option 3' +
      '</div>' +
      '</div>' +
      '</div>' +
      '</div>';

    var cardcontent = "";
    for (var i = 0; i < no; i++) {
      cardcontent = cardcontent + card;
    }

    var contentHtml = '<p><div style="width: 100%;height:auto;display:inline-block">' + cardcontent + '</div></p>';
    return contentHtml;
  }

  cmsInsert(): Observable<any> {
    return new Observable((data) => {
      var timer = setInterval(() => {
        if (this.cmsInserted) {
          clearInterval(timer);
          data.next({ stat: "selected", content: this.insertedCmsId });
          data.complete();
        }
      }, 0);
    });
  }

  cmsSelected(e, cms) {
    console.log(e.target);
    this.insertTemplateName = cms.title;
    this.insertedCmsId = e.target.value;
  }

  cmsTemplateInsert() {
    console.log("insert name" + this.insertTemplateName);
    this.insertedCmsId = null;
    this.insertedCmsId = "<span data-class='cmsTemplate' style='cursor:pointer;color:#007bff' data-id=" +
      this.selectedSearchTemplate._id + ">" + this.insertTemplateName + "</span>";
    this.cmsInserted = true;
    //$("#cmsTemplateSelectionDiv").addClass("hide");
  }

  searchTemplate(searchterm) {
    this.isLoadingSearchTemplate = true;
    this.cmsStudioService.searchCmsByTitle(searchterm, this.companyCode)
      .subscribe(res => {
        console.log(res);
        this.isLoadingSearchTemplate = false;
        this.searchTemplateList = res.cmsList;
      })
  }

  openLinkExistingTemplateModal(modaltemp) {
    const modal = this.modalService.open(this.linkExistingTemplateModal, { centered: true, windowClass: 'link-existing-modal' });
    modal.result.then(() => {
      this.searchTemplateList = null;
      this.selectedSearchTemplate = null;
      this.insertTemplateName = null;
    }, () => {
      this.searchTemplateList = null;
      this.selectedSearchTemplate = null;
      this.insertTemplateName = null;
    })
  }

  /*treeviewSelected(e) {
    var data = JSON.parse(e);
    console.log(data);

    if (data.item.value.hasOwnProperty('_id')) {
      this.selectedCms = this.cmsList[this.cmsList.findIndex(cl => cl._id == data.item.value._id)];
      this.selectedSubPageId = null;
    }
    else {
      var d = this.cmsList.findIndex(cm => cm._id == data.item.value.superParent_id);
      if (d >= 0) {
        this.selectedCms = this.cmsList[d];
        this.selectedSubPageId = data.item.value.id;
      }
    }

    if (data.addNew) {
      this.addNewCms();
      this.openAddPageModal();

    }
    else {
      this.newCms = data.item.value;
    }
  }*/

  filterCms(filterterm) {
    //console.log('inside filter');
    filterterm = filterterm.toLowerCase();
    if (filterterm && filterterm != '') {
      this.cmsList = [];
      this.cmsSourceList.forEach(cl => {
        if (cl.title.toLowerCase().includes(filterterm)) this.cmsList.push(cl);
        else {
          if (cl.subPages)
          // cl.subPages.forEach(sp => {
          //   if (sp.title.toLowerCase().includes(filterterm)) this.cmsList.push(cl);
          // })
          {
            for (var i = 0; i < cl.subPages.length; i++) {
              if (cl.subPages[i].title.toLowerCase().includes(filterterm)) {
                this.cmsList.push(cl);
                break;
              }
            }
          }
        }
      })
    } else {
      this.cmsList = this.cmsSourceList;
    }
  }

  deleteCmsRoot() {
    if (this.isSubPageSelected) {
      var index = this.subPageParentCms.subPages.findIndex(sp => sp._id == this.newCms._id);
      if (index >= 0) {
        this.removeSubpage(this.subPageParentCms, index);
      }
    }
    else {
      this.deleteCms(this.newCms._id);
    }
  }

  removeSubpage(cl, subpageIndex) {
    //console.log("inside removeSubpage");
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this item!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      confirmButtonColor: '#ffaa00',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      console.log(result);
      if (result.value) {
        cl.subPages.splice(subpageIndex, 1);
        this.createOrUpdateHelper(cl, false);
        this.selectedCms = null;
        this.addNewCms();
      }
    })
  }

  deleteCms(cmsid) {
    //console.log("inside deletecms");
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this item!',      
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      confirmButtonColor: '#ffaa00',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
        this.cmsStudioService.deleteCmsById(cmsid)
          .subscribe(res => {
            console.log(res);
            this.addNewCms();
            this.selectedCms = null;
            this.getAllActiveCms();
          })
      }
    });
  }

  getTemplateLink(id) {
    var ret = "";
    ret = window.location.origin + "/kb/" + id;
    return ret;
  }

  copyLink() {
    this.postMsg = "Link copied successfully.";
    setTimeout(() => {
      this.postMsg = null;
    }, 2000)
  }

  getPermission(newCms: Cms, role) {
    var ret = false;

    if (role == 'owner') {
      //console.log(newCms.owners);
      if (newCms.owners) {
        newCms.owners.forEach(ur => {
          if (ur.userName == this.loginId && ur.accountId == this.accountId) ret = true;
        })
      }
    }
    if (role == 'contr') {
      if (newCms.contributors) {
        newCms.contributors.forEach(ur => {
          if (ur.userName == this.loginId && ur.accountId == this.accountId) ret = true;
        })
      }
    }


    return ret;
  }

  dragulaChangeEvent(event, cmsid) {
    //console.log(event) 
    event.forEach((ev, i) => {
      if (!ev || !ev._id) event.splice(i, 1);
    })
    event.forEach((ev, i) => {
      ev.orderId = i + 1;
    })
    console.log(event)
    this.cmsStudioService.updateCmsBatch(event, cmsid)
      .subscribe((res: any) => {
        console.log(res)
        this.getAllActiveCms();
      })
  }

  trackByIdx(index: number, obj: any): any { return index; }

  navigateTo(url: string) {
    this.router.navigate([url]);
  }

  onAddNewCms() {
    this.openAddPageModal(); 
    this.selectedCms = null; 
    this.addNewCms(); 
    this.isShowEditor = true;
  }
}

